module.exports = __webpack_public_path__ + "img/invalid.c0c412b8.png";